package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.LockpickingRepository

/**
 * Use case for marking a lockpicking challenge as timed out (triggered by player-side countdown).
 */
class TimeoutLockpickingUseCase(
    private val lockpickingRepository: LockpickingRepository
) {
    suspend operator fun invoke(
        lockpickingId: String
    ): Result<Unit> {
        return lockpickingRepository.timeout(
            lockpickingId = lockpickingId
        )
    }
}
